import CardPostDetail from 'components/CardPostDetail';
import Layout from 'Layout'
import React from 'react'
import { useParams } from 'react-router-dom';
import { useCallback } from 'react';
import { getKegiatanById } from 'services/apiRoutes';
import { useState } from 'react';
import { useEffect } from 'react';
import SkeletonCapaian from 'skeletons/SkeletonCapaian';
import SkeletonArticle from 'skeletons/SkeletonArticle';

export default function PostKegiatan() {
  const {id} = useParams();

  const [loading,setLoading]= useState(false);

  const[kegiatan,setKegiatan]=useState();


  const kegiatanAPI = useCallback(async(id)=>{
    setLoading(true);
    const res = await getKegiatanById(id);
    if (res.error) {
      return res.message
    }else{
      const {data} = res.data;
      setKegiatan(data);
      setLoading(false);
    }
  },[])

  useEffect(() => {
    kegiatanAPI(id);
  }, [kegiatanAPI,id]);


  return (
    <Layout>
      <div className="items-center px-5 xl:pt-44 pt-28 kegiatan-wrapper xl:px-99">
        <h1 className="mb-12 text-2xl font-bold xl:text-7xl">
          {kegiatan?.nama}
        </h1>
        <div className="justify-between mb-32 space-y-5 xl:flex contentWrapper xl:space-y-0">
          <div className="postImage xl:w-[60%] rounded-2xl ">
            {!loading ? (
              <img
                src={kegiatan?.url_gambar}
                alt="gambar postingan"
                className="rounded-2xl"
                crossOrigin="anonymous"
              />
            ) : (
              <SkeletonCapaian />
            )}
          </div>
          <div className="xl:w-[30%]">
            <CardPostDetail
              lokasi={kegiatan?.lokasi}
              date={kegiatan?.tanggal}
              timeStart={kegiatan?.waktu_mulai?.substring(0, 5)}
              timeLeft={kegiatan?.waktu_selesai?.substring(0, 5)}
            />
          </div>
        </div>
        <div className="p-5 leading-6 border xl:p-10 rounded-2xl border-borderCardFeatures mb-28">
          {kegiatan ? (
            <div
              dangerouslySetInnerHTML={{
                __html: kegiatan?.isi || kegiatan?.deskripsi || kegiatan?.content || "",
              }}
            />
          ) : (
            <SkeletonArticle />
          )}

          {kegiatan?.fileUrl && (
            <div className="mt-8">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Lampiran PDF</h3>
              <div className="w-full h-[600px] rounded-2xl overflow-hidden border border-gray-200">
                <iframe 
                  src={kegiatan.fileUrl} 
                  title="Lampiran Dokumen PDF" 
                  className="w-full h-full"
                />
              </div>
              <div className="mt-4">
                <a 
                  href={kegiatan.fileUrl} 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-lg shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none"
                >
                  Buka PDF di Tab Baru
                </a>
              </div>
            </div>
          )}
          {/* <p className="text-justify text-articleTitle">
            {kegiatan ? kegiatan?.deskripsi : <SkeletonArticle />}
          </p> */}
        </div>
        {/* <div className="p-5 leading-6 border xl:p-10 rounded-2xl border-borderCardFeatures mb-28">
          <p className="text-justify text-articleTitle">
            Pada zaman dahulu kala, nama Gampong Geulanggang Teungoh merupakan
            gampongnya areal perternakan yang sangat dikenal dikalangan
            masyarakat Bireuen. Menurut cerita tokoh-tokoh masyarakat Bireuen,
            nama gampong tersebut bermula dari pengembalaan binatang ternak yang
            sangat banyak yang dilakukan masyarakat Bireuen. Gampong tersebut
            menjadi{" "}
            <span className="font-semibold text-spanBolder">
              ”Arena (Gelanggang)”
            </span>{" "}
            tempat hewan-hewan ternak yang dilepaskan bebas saling beradu. Di
            samping itu juga ada suatu lokasi yang dahulu dikenal dengan{" "}
            <span className="font-semibold text-spanBolder">
              ”Uteuen Rambong (Hutan atau Kebun Karet)”
            </span>{" "}
            yang sering dikunjungi masyarakat Bireuen pada sore dan malam hari
            untuk menonton berbagai macam acara kesenian budaya rakyat Aceh yang
            ditampilkan dilokasi tersebut.
          </p>
          <p className="text-justify text-articleTitle">
            Dicetuskanlah nama{" "}
            <span className="font-semibold text-spanBolder">
              Gampong Geulanggang Teungoh
            </span>{" "}
            yang disebabkan berada ”ditengah” yang diapit oleh Gampong lain yang
            sebelah Utara berbatasan dengan Gampong Geulanggang Kulam dan
            sebelah selatan dengan Gampong Geulanggang Gampong. Sekarang Sebelah
            Timur berbatas dengan Gampong Geulanggang Baro yang merupakan
            gampong pemekaran sejak tahun 2005 yang sebelumnya wilayahnya Dusun
            Baru Gampong Geulanggang Teungoh. Gampong Geulanggang Teungoh yang
            memiliki wilayahnya seluas 248 Ha berdiri sekitar pada tahun 1920.
            Gampong Geulanggang Teungoh yang terdiri dari 4 dusun, antara lain:
            Dusun Timur, Dusun Teungoh, Dusun Barat dan Dusun Lagang.
          </p>
        </div> */}
      </div>
    </Layout>
  );
}
